module.exports = __webpack_public_path__ + "img/list_2.f109fa71.jpg";